import { FormTabs } from "@4uhub/lib4uhub";
import { Box } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { SalesContractHcpInclusionRulePage } from "../SalesContractHcpInclusionRule/SalesContractHcpInclusionRulePage";

const translationPath =
  "page.4uSalesContract.registers.baseContracts.salesContractRules.";

export const SalesContractRules = memo(() => {
  const { t } = useTranslation();
  let tabs = [
    {
      label: t(translationPath + "sales_contract_hcp_inclusion_rule"),
      component: <SalesContractHcpInclusionRulePage />,
    },
  ];
  return (
    <Box
      sx={(t) => ({
        p: 1,
        borderRadius: 1,
        backgroundColor:
          t.palette.mode === "light" ? "#fff" : t.palette.grey[900],
      })}
    >
      <FormTabs
        tabs={tabs}
        sxTab={{
          backgroundColor: "transparent",
        }}
      />
    </Box>
  );
});
